import { render, staticRenderFns } from "./CompanyInfo_Categories.vue?vue&type=template&id=220a0552"
import script from "./CompanyInfo_Categories.vue?vue&type=script&lang=js"
export * from "./CompanyInfo_Categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports